import React from "react";
import Wprr from "wprr";
import Dbm from "dbm";

import ImageLoaderManager from "wprr/imageloader/ImageLoaderManager";

import RoutingModuleCreator from "wprr/modulecreators/RoutingModuleCreator";

import SingularPage from "wf/components/SingularPage";
import ItemsSetup from "wf/setup/ItemsSetup";

import * as wpBlocks from "wf/components/wp-blocks.js";
import * as wprrWpBlocks from "wprr/elements/wp-blocks.js";

{
	Dbm.setupGlobalInstance();
	Dbm.updater.webSetup();
	Dbm.getRepositoryItem("site/translations").requireProperty("data", {});
	Dbm.tracking.setup();
	Dbm.tracking.addTagManagerTracking("GTM-MLP78R8B");

	let globalWprr = new Wprr();
	globalWprr.addGlobalReference(window);
	
	if(!globalWprr.imageLoaderManager) globalWprr.imageLoaderManager = new ImageLoaderManager();
	
	let routingModuleCreator = new RoutingModuleCreator();
	routingModuleCreator.skipPreloadedData = true;
	routingModuleCreator._siteNavigation.allowedPaths = [new RegExp(".*$")];
	
	let project = globalWprr.getProject("wf");
	routingModuleCreator.setProject(project);
	
	project.item.setValue("titleSuffix", " - Whiston farm");
	
	let dataLayerTracker = Wprr.utils.data.multitypeitems.controllers.tracking.DataLayerTracker.create(project.items.createInternalItem());
	project.tracking.addTracker(dataLayerTracker.item.id);
	
	ItemsSetup.registerInProject(project);
	
	let mainMarkup = <Wprr.Markup>
		<div className="main-font-setting">
			<Wprr.MarkupChildren placement="header" />
			<Wprr.MarkupChildren placement="routes" />
			<Wprr.MarkupChildren placement="footer" />
			<Dbm.react.cookies.CookieOverlayMessage />
		</div>
	</Wprr.Markup>;

	routingModuleCreator.setMarkup(mainMarkup);
	
	routingModuleCreator.createSingularRoute(<SingularPage />);
	
	globalWprr.addModuleCreator("index", routingModuleCreator);
	
	let mainReferenceHolder = routingModuleCreator.getReferenceHolder();
	
	Wprr.utils.blockInjection.addBlockFromModule(wpBlocks, mainReferenceHolder);
	Wprr.utils.blockInjection.addBlockFromModule(wprrWpBlocks, mainReferenceHolder);
	
	mainReferenceHolder.addObject("wprr/defaultImageLocation", "images");
	
	globalWprr.imageLoaderManager.start();
}